import {productSearch} from "../../services/api/Product";

class SearchService {
  constructor() {
    this.searchResults = [];
    this.currentQuery = "";
    this.currentLimit = 10;
    this.hasMore = true;
    this.isLoading = false;
  }

  async search(query, limit = 10, reset = true) {
    if (!query || query.trim() === "") {
      this.reset();
      return [];
    }

    if (reset) {
      this.reset();
      this.currentQuery = query;
      this.currentLimit = limit;
    }

    if (this.isLoading) return this.searchResults;
    
    this.isLoading = true;

    try {
      const response = await productSearch(
        this.currentQuery,
        "both",
        this.currentLimit,
        "external"
      );

      if (response?.data?.success && response?.data?.data?.suggestions) {
        const newResults = response.data.data.suggestions;
        
        if (reset) {
          this.searchResults = newResults;
        } else {
          this.searchResults = [...this.searchResults, ...newResults];
        }

        // Check if we have more results
        const totalCount = response.data.data.metadata?.totalCount || 0;
        this.hasMore = this.searchResults.length < totalCount;
        
        return this.searchResults;
      }
      
      return reset ? [] : this.searchResults;
    } catch (error) {
      console.error("Search error:", error);
      return reset ? [] : this.searchResults;
    } finally {
      this.isLoading = false;
    }
  }

  async loadMore() {
    if (!this.hasMore || this.isLoading) return this.searchResults;
    
    this.currentLimit += 10;
    return await this.search(this.currentQuery, this.currentLimit, false);
  }

  reset() {
    this.searchResults = [];
    this.currentQuery = "";
    this.currentLimit = 10;
    this.hasMore = true;
    this.isLoading = false;
  }

  getResults() {
    return this.searchResults;
  }

  getHasMore() {
    return this.hasMore;
  }
}

export default new SearchService();